import { Component, OnInit, Input } from '@angular/core';
import { MemberService } from '@services/member.service';
import { LanguageService } from '@services/language.service';
import { Member } from '@models/member.model';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
  // eslint-disable-next-line
  standalone: false,
})
export class LanguageSelectorComponent implements OnInit {
  @Input() notLoggedIn: boolean = false;
  currentLanguage = '';
  currentMember: Member | null = null;
  languages: string[] = [];

  constructor(
    private memberService: MemberService,
    private languageService: LanguageService,
  ) {}

  ngOnInit(): void {
    this.initializeLanguages();
    if (!this.notLoggedIn) {
      this.loadCurrentMember();
    }
  }

  private initializeLanguages(): void {
    // Get supported languages from the service
    const supportedLangs = this.languageService.getSupportedLanguages();

    this.languages = supportedLangs.filter(lang => lang !== 'zz'); // Filter out the test language

    this.currentLanguage = this.languageService.getCurrentLanguage();
  }

  private loadCurrentMember(): void {
    this.memberService
      .current()
      .pipe(take(1))
      .subscribe((member: Member | null) => {
        if (member) {
          this.currentMember = member;
          this.currentLanguage = member.language || this.currentLanguage;
        }
      });
  }

  onLanguageChange(languageCode: string): void {
    this.currentLanguage = languageCode;

    if (this.notLoggedIn) {
      // When not logged in, just update the language in the service

      this.languageService.setMemberLanguage(languageCode, 'de');
      return;
    }

    if (!this.currentMember) {
      return;
    }

    // Update member's language
    this.currentMember.language = languageCode;

    // Save the member with updated language
    this.currentMember.save().subscribe(
      () => {
        // Update the language service
        this.languageService.setMemberLanguage(
          languageCode,
          this.currentMember?.companySetting?.language || 'en',
        );
      },
      error => {
        console.error('Error updating language:', error);
        // Revert on error
        this.loadCurrentMember();
      },
    );
  }
}
